import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ListFeedbackResponse } from '@shared/schemas';

import { initialState } from './list-feedbacks.state';

/**
 * List Feedbacks slice (#717). Reducers are pure state transitions only; every
 * fetch and write lives in the saga, which dispatches these as it progresses.
 */
const slice = createSlice({
  name: 'listFeedbacks',
  initialState,
  reducers: {
    // ── Table load ──
    loadStarted: (state) => {
      state.loadStatus = 'loading';
    },
    loadSucceeded: (state, action: PayloadAction<ListFeedbackResponse[]>) => {
      state.feedbacks = action.payload;
      state.loadStatus = 'loaded';
    },
    loadFailed: (state) => {
      state.loadStatus = 'failed';
    },

    // ── Sidebar badge ──
    openCountLoaded: (state, action: PayloadAction<number>) => {
      state.openCount = action.payload;
    },

    // ── Status change ──
    statusUpdateStarted: (state, action: PayloadAction<string>) => {
      state.statusUpdate = { pendingId: action.payload, error: null };
    },
    statusUpdated: (state, action: PayloadAction<ListFeedbackResponse>) => {
      const i = state.feedbacks.findIndex((f) => f.id === action.payload.id);
      if (i >= 0) state.feedbacks[i] = action.payload;
      state.statusUpdate = { pendingId: null, error: null };
    },
    statusUpdateFailed: (state, action: PayloadAction<string>) => {
      state.statusUpdate = { pendingId: null, error: action.payload };
    },
    statusUpdateErrorCleared: (state) => {
      state.statusUpdate.error = null;
    },
  },
});

export const listFeedbacksActions = slice.actions;
export const listFeedbacksReducer = slice.reducer;
